var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isReady)?_c('div',[(!_vm.$vuetify.breakpoint.xsOnly)?_c('span',[_vm._v(" "+_vm._s(_vm.year)+"/"+_vm._s(_vm.mon)+"/"+_vm._s(_vm.date)+"("+_vm._s(_vm.day)+") ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.hour)+":"+_vm._s(_vm.min)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }